import React, { useState } from "react";
import { IconUser, IconLogout } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";

export default function Footer() {
  const [showMenu, setShowMenu] = useState(false);
  const logout = useAuthStore((state: any) => state.logout);
  const isAuthenticated = useAuthStore(
    (state: { isAuthenticated: any }) => state.isAuthenticated
  );

  const handleLogout = () => {
    logout();
    window.location.href = "/login";
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <footer className="border-t border-gray-200 fixed bottom-0 w-full bg-white shadow-lg">
      <div className="flex h-16 items-center justify-center px-4">
        <div className="relative">
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200"
          >
            <IconUser size={24} stroke={1.5} className="text-gray-700" />
            <span className="text-xs font-medium text-gray-700">Perfil</span>
          </button>

          {showMenu && (
            <>
              {/* Overlay para cerrar el menú */}
              <div
                className="fixed inset-0 z-10"
                onClick={() => setShowMenu(false)}
              />

              {/* Menú desplegable */}
              <div className="absolute bottom-full right-0 mb-2 w-48 bg-white rounded-xl shadow-xl border border-gray-200 z-20 overflow-hidden">
                <Link
                  to="/profile"
                  className="px-4 py-3 hover:bg-gray-50 flex items-center gap-3 transition-colors duration-200"
                  onClick={() => setShowMenu(false)}
                >
                  <IconUser size={18} className="text-gray-600" />
                  <span className="text-sm font-medium text-gray-700">
                    Mi Perfil
                  </span>
                </Link>
                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 flex items-center gap-3 transition-colors duration-200"
                >
                  <IconLogout size={18} />
                  <span className="text-sm font-medium">Cerrar Sesión</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </footer>
  );
}
